<template src="./about.html"></template>

<script>
  export default {}
</script>

<style>

</style>
